export default {
	methods: {
		ucFirst: function( input ) {
			return input.charAt(0).toUpperCase() + input.slice(1);
		}
	}
}